import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';
import {host} from '../../function/api'

export const editSectionThree = createAsyncThunk(
    'editSectionThree',
    async(data, thunkApi) => {
        try {
            const response = await axios({
                method: 'POST',
                _method: 'PATCH',
                url: `${host}sectionThree/${data.id}`,
                data: data,
                headers: {
                    'Accept': 'Application/json',
                    'Authorization': `Bearer ${localStorage.getItem('token')}`,
                    'xsrfHeaderName': "X-XSRF-TOKEN",
                    'withCredentials': true,
                }
        })

            return response.data;

        } catch (error) {
            return thunkApi.rejectWithValue(error);
        }
    }
)

export const sectionIndex = createAsyncThunk(
    'section/index',
    async(data, thunkApi) => {
        try {
            const response = await axios({
                method: 'GET',
                url: `${host}sectionThree?section=${data.section}&page=${data.pageNumber}&per_page=${data.countPerPage}&search=${data.search}&delay=1`,
                headers: {
                    'Accept': 'Application/json',
                    'Authorization': `Bearer ${localStorage.getItem('token')}`,
                    'xsrfHeaderName': "X-XSRF-TOKEN",
                    'withCredentials': true,
                }
        })

            return await response.data;

        } catch (error) {
            return thunkApi.rejectWithValue(error);
        }
    }
)

export const sectionStore = createAsyncThunk(
    'section/store',
    async(data, thunkApi) => {
        try {
            const response = await axios.post(
                `${host}sectionThree`,
                data,{
                    headers: {
                        'Accept': 'Application/json',
                        'xsrfHeaderName': "X-XSRF-TOKEN",
                        'withCredentials': true,
                        'Authorization': `Bearer ${localStorage.getItem('token')}`
                    }        
                })

            return await response.data;

        } catch (error) {
            return thunkApi.rejectWithValue(error);
        }
    }
)

const initialState= {
    archiveSectionThreeLoading: false,
    archiveSectionThreeSuccess: false,
    sectionsThree: [],
    errorSectionThree: '',
    errorTitle: '',
    CreateSectionThree: '',
    message: '',
    error: ''
}

const sectionThreeSlice = createSlice({
    name: 'sectionThree',
    initialState,
    reducers: {

    },
    extraReducers: {
        [editSectionThree.fulfilled]: (state, {payload}) => {  
            state.archiveSectionThreeLoading = false
            state.archiveSectionThreeSuccess = true
            state.message = payload.message
            state.errorTitle = ""
            state.errorArchive = ""
        },
        [editSectionThree.pending] : (state) => {
            state.archiveSectionThreeLoading = true    
            state.archiveSectionThreeSuccess = false
            state.message = ""
        },
        [editSectionThree.rejected]: (state, {payload}) => {
            state.archiveSectionThreeLoading = false
            state.archiveSectionThreeSuccess = false
            
            state.message = payload.response.data.message
            
        },
        [sectionStore.fulfilled]: (state, {payload}) => {
            state.archiveSectionThreeLoading = false
            state.archiveSectionThreeSuccess = true
            state.CreateSectionThree = payload.message
            state.errorTitle = ""
            state.errorSectionTwo = ""
            state.message = ""
        },
        [sectionStore.pending] : (state) => {
            state.archiveSectionThreeLoading = true    
            state.archiveSectionThreeSuccess = false
            state.CreateSectionThree = ""
            state.message = ""
        },
        [sectionStore.rejected]: (state, {payload}) => {
            state.archiveSectionThreeLoading = false
            state.archiveSectionThreeSuccess = false
            state.CreateSectionThree = payload.response.data.message
            state.message = ""
            
        },
        [sectionIndex.fulfilled]: (state, action) => {
            state.archiveSectionThreeLoading = false
            state.sections = action.payload.data
            state.previous = action.payload.previous
            state.rahpardaznetLoading = false;
            state.errorTitle = ""
            state.errorSectionThree = ""
            state.CreateSectionThree = ""
            state.message = ""
        },
        [sectionIndex.pending]: (state) => {
            state.archiveSectionThreeLoading = true
            state.rahpardaznetLoading = true;
            state.CreateSectionThree = ""
            state.message = ""
        },
        [sectionIndex.rejected]: (state, {payload}) => {
            state.archiveSectionThreeLoading = false;
            state.archiveSectionThreeSuccess = false
            state.rahpardaznetLoading = false;
            if(payload.response.data.error){
                state.error = payload.response.data.error
            } else if (payload.response.data.message) {
                state.message = payload.response.data.message
            }else{
                state.message = ""
            }
            state.CreateSectionThree = ""
        }
    }
})

export const {} = sectionThreeSlice.actions;
export default sectionThreeSlice.reducer; 